import clsx from 'clsx';
import type { PropsWithChildren } from 'react';
import { useCreditCard } from './CreditCard';

type CreditCardContentProps = PropsWithChildren;

export const CreditCardContent = ( { children }: CreditCardContentProps ) => {
  const creditCard = useCreditCard();

  const Components = Array.isArray( children ) ? children : [ children ];
  const CreditCardNumber = Components.find( c => c?.type?.displayName === 'CreditCardNumber' );
  const CreditCardDate = Components.find( c => c?.type?.displayName === 'CreditCardDate' );
  const CreditCardCvv = Components.find( c => c?.type?.displayName === 'CreditCardCvv' );
  const CreditCardFlag = Components.find( c => c?.type?.displayName === 'CreditCardFlag' );
  const CreditCardBalance = Components.find( c => c?.type?.displayName === 'CreditCardBalance' );

  return (
    <div className={ 'absolute bottom-0 left-0 inset-0' } >
      { ( CreditCardNumber || CreditCardDate || CreditCardCvv ) && (
        <div className={ clsx(
          'grid grid-cols-[max-content_1fr] absolute bottom-[8%] left-[6%]',
          {
            'gap-x-8 gap-y-3.5': creditCard.size === 'default',
            'gap-x-4 gap-y-1 ': creditCard.size === 'sm'
          }
        ) }>
          {CreditCardNumber && (
            <div className={ 'col-span-full' }>
              {CreditCardNumber}
            </div>
          )}
          {CreditCardDate}
          {CreditCardCvv}
        </div>
      )}
      { ( CreditCardFlag || CreditCardBalance ) && (
        <div className={ 'absolute top-[8%] right-[6%] flex flex-col items-end gap-2.5' }>
          {CreditCardBalance}
          {CreditCardFlag}
        </div>
      )}
    </div>
  )
}
CreditCardContent.displayName = 'CreditCardContent';
